// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-F":"GS_outdoor-recreation-F__X7IBs"};